import React, { useState } from 'react';
import { loadModules } from "esri-loader";
// import illinoisStations from "../../Data/illinois_substations.json";
import coloradoStations from "../../Data/colorado_substations.json";


export function loadMap(container, basemap) {
  return loadModules(
    ["esri/Map",
      "esri/views/SceneView",
      "esri/layers/GraphicsLayer",
      "esri/Graphic",
      "esri/widgets/Sketch/SketchViewModel",
      "esri/layers/FeatureLayer"],
    // this stylesheet is only loaded once
    { css: "https://js.arcgis.com/4.10/esri/css/main.css" }
  ).then(([Map, SceneView, GraphicsLayer, Graphic, SketchViewModel, FeatureLayer]) => {

    const map = new Map({
      basemap: "satellite"
    });

    const bikeTrailsRenderer = {
      type: "simple",
      symbol: {
        type: "simple-line",
        color: "#de101d",
        width: "5px"
      }
    };

    // Define elevationInfo and set it on the layer
    const currentElevationInfo = {
      mode: "relative-to-ground",
      offset: 100,
      featureExpressionInfo: {
        expression: "Geometry($feature).z * 10"
      },
      unit: "meters"
    };

    const lineLayer = new FeatureLayer({
      // url: "https://services.arcgis.com/V6ZHFr6zdgNZuVG0/ArcGIS/rest/services/Electric_Line/FeatureServer/110",
      url: "https://services1.arcgis.com/Hp6G80Pky0om7QvQ/arcgis/rest/services/Transmission_Lines_gdb/FeatureServer/0",
      renderer: bikeTrailsRenderer,
      popupTemplate: {
        title: "{NAME}",
        outFields: ["OWNER", "VOLTAGE", "SUB_1", "SUB_2"],
        lastEditInfoEnabled: false,
        actions: [
          {
            id: "find-station",
            image: "https://developers.arcgis.com/javascript/latest//sample-code/popup-custom-action/live/beer.png",
            title: "Station Info"
          }
        ],
        content: [
          {
            type: "fields",
            fieldInfos: [
              {
                fieldName: "OWNER"
              },
              {
                fieldName: "VOLTAGE",
              },
              {
                fieldName: "SUB_1",
              },
              {
                fieldName: "SUB_2"
              }
            ]
          }
        ]
      }
    });

    lineLayer.elevationInfo = currentElevationInfo;

    const view = new SceneView({
      container,
      map: map,
      center: [-105.009065, 39.618691], // Longitude, latitude
      zoom: 15, // Zoom level
      // camera: {
      //   // autocasts as new Camera()
      //   position: {
      //     // autocasts as new Point()
      //     x: -0.17746710975334712,
      //     y: 51.44543992422466,
      //     z: 1266.7049653716385
      //   },
      //   heading: 0.34445102566290225,
      //   tilt: 82.95536300536367
      // }
    });

    /*********************
         * Add graphics layer
         *********************/

    const graphicsLayer = new GraphicsLayer();
    map.add(graphicsLayer);
    map.add(lineLayer);
    /*************************
     * Add 3D substation point graphics
     *************************/
    coloradoStations.forEach((stationData, index) => {
      const pointGraphic = new Graphic({
        geometry: {
          type: "point", // autocasts as new Point()
          x: stationData.LONGITUDE,
          y: stationData.LATITUDE,
          z: 250
        },
        symbol: {
          type: "simple-marker",
          color: [226, 119, 40],  // Orange
          outline: {
            color: [255, 255, 255], // White
            width: 4
          },
        },
        attributes: {
          Name: stationData.NAME,
          Description: stationData.NAICS_DESC,
          ObjectId: stationData.OBJECTID
        },
        popupTemplate: {
          title: "{Name}",
          objectId: "{ObjectId}",
          actions: [
            {
              id: "find-substation",
              image: "https://static.thenounproject.com/png/2496215-200.png",
              title: `Load ${stationData.NAME} Twin Model`
            }
          ],
          content: [
            {
              type: "fields",
              fieldInfos: [
                {
                  fieldName: `Station Name: ${stationData.NAME}`
                },
                {
                  fieldName: `Max Voltage: ${stationData.MAX_VOLT}`
                },
                {
                  fieldName: `Min Voltage: ${stationData.MIN_VOLT}`
                },
                {
                  fieldName: `No. of Lines: ${stationData.LINES}`
                },
                {
                  fieldName: `NAICS Desc: ${stationData.NAICS_DESC}`
                },
                {
                  fieldName: `City: ${stationData.CITY}`
                },
                {
                  fieldName: `County: ${stationData.COUNTY}`
                },
                {
                  fieldName: `Status: ${stationData.STATUS}`
                },
                {
                  fieldName: `Updated On: ${stationData.SOURCEDATE}`
                }
              ],
            },
          ],
        }
      });
      graphicsLayer.add(pointGraphic);

      const polylineGraphic = new Graphic({
        geometry: {
          type: "polyline", // autocasts as new Polyline()
          paths: [
            [stationData.LONGITUDE, stationData.LATITUDE, 0],
            [stationData.LONGITUDE, stationData.LATITUDE, 250]
          ]
        },
        symbol: {
          type: "simple-line", // autocasts as SimpleLineSymbol()
          color: [226, 119, 40],
          width: 4
        },
        attributes: {
          Name: stationData.NAME,
          Description: stationData.NAICS_DESC,
          ObjectId: stationData.OBJECTID
        },
        popupTemplate: {
          title: "{Name}",
          objectId: "{ObjectId}",
          actions: [
            {
              id: "find-substation",
              image: "https://static.thenounproject.com/png/2496215-200.png",
              title: `Load ${stationData.NAME} Twin Model`
            }
          ],
          content: [
            {
              type: "fields",
              fieldInfos: [
                {
                  fieldName: `Station Name: ${stationData.NAME}`
                },
                {
                  fieldName: `Max Voltage: ${stationData.MAX_VOLT}`
                },
                {
                  fieldName: `Min Voltage: ${stationData.MIN_VOLT}`
                },
                {
                  fieldName: `No. of Lines: ${stationData.LINES}`
                },
                {
                  fieldName: `NAICS Desc: ${stationData.NAICS_DESC}`
                },
                {
                  fieldName: `City: ${stationData.CITY}`
                },
                {
                  fieldName: `County: ${stationData.COUNTY}`
                },
                {
                  fieldName: `Status: ${stationData.STATUS}`
                },
                {
                  fieldName: `Updated On: ${stationData.SOURCEDATE}`
                }
              ],
            },
          ],
        }
      });

      graphicsLayer.add(polylineGraphic);

    });

    const tentBtn = document.getElementById("tent");
    const canoeBtn = document.getElementById("canoe");
    const opacityInput = document.getElementById("opacityInput");
    const configButton = document.getElementById("configBtn");

    view.when(() => {
      // This sample uses the SketchViewModel to add points to a
      // GraphicsLayer. The points have 3D glTF models as symbols.
      const sketchVM = new SketchViewModel({
        layer: graphicsLayer,
        view: view
      });

      tentBtn.addEventListener("click", (event) => {
        // reference the relative path to the glTF model
        // in the resource of an ObjectSymbol3DLayer
        sketchVM.pointSymbol = {
          type: "point-3d",
          symbolLayers: [
            {
              type: "object",
              resource: {
                href: "/assets/stationEncloded2.glb"
              }
            }
          ]
        };
        sketchVM.create("point");
        deactivateButtons();
        this.classList.add("esri-button--secondary");
      });
      

      canoeBtn.addEventListener("click", () => {
        // reference the relative path to the glTF model
        // in the resource of an ObjectSymbol3DLayer
        sketchVM.pointSymbol = {
          type: "point-3d",
          symbolLayers: [
            {
              type: "object",
              resource: {
                href: "https://sdsic-images.s3.amazonaws.com/Gltfs/DigitalTwinStation1.glb"
              }
            }
          ]
        };
        deactivateButtons();
        sketchVM.create("point");
        this.classList.add("esri-button--secondary");
      });

      sketchVM.on("create", (event) => {
        if (event.state === "complete") {
          sketchVM.update(event.graphic);
          deactivateButtons();
        }
      });

      // Watch for when features are selected
      view.popup.watch("selectedFeature", (graphic) => {
        if (graphic) {
          // Set the action's visible property to true if the 'website' field value is not null, otherwise set it to false
          const graphicTemplate = graphic.getEffectivePopupTemplate();
          graphicTemplate.actions.items[0].visible = graphic.attributes.ObjectId ? true : false;
        }
      });

      const popup = view.popup;
      popup.viewModel.on("trigger-action", (event) => {
        if (event.action.id === "find-substation") {
          const attributes = popup.viewModel.selectedFeature.attributes;
          // Get the 'website' field attribute
          const info = attributes.ObjectId;
          // Make sure the 'website' field value is not null
          if (info) {
            // Open up a new browser using the URL value in the 'website' field
            // window.open(info.trim());

            var domElem = document.getElementById('selectedStation');
            domElem.innerText = attributes.Name; //attributes.ObjectId;              
            localStorage.setItem('projectName', attributes.Name);
          }
        }
      });

      // the webscene has no basemap, so set a surfaceColor on the ground
      // map.ground.surfaceColor = "#fff";
      // to see through the ground, set the ground opacity to 0.4
      map.ground.opacity = 1;
      map.ground.navigationConstraint = {
        type: "stay-above"
      }

      opacityInput.addEventListener("change", (event) => {

        if (event.target.checked === true) {
          map.ground.opacity = 0.8;

          map.ground.navigationConstraint = {
            type: "none"
          }
        } else {

          map.ground.opacity = 1;
          map.ground.navigationConstraint = {
            type: "stayAbove"
          }
        }

      });



    })
      .catch(console.error);

    function deactivateButtons() {
      const elements = Array.prototype.slice.call(document.getElementsByClassName("esri-button"));
      elements.forEach((element) => {
        // element.classList.remove("esri-button--secondary");
      });
    }


    view.ui.add(document.getElementById('paneDiv'), "top-right");

    return view;
  });
}
